import { render } from "./FileInput.vue?vue&type=template&id=37141c04"
import script from "./FileInput.vue?vue&type=script&lang=js"
export * from "./FileInput.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Reina\\Documents\\Code\\Laravel\\telegrambot2\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__